import React from "react";
import { getColumnMonthData } from "../../../../../utils/annual-planner-helpers";
import {
  EventCounter,
  MonthCard,
  NutritionTargets,
  PhaseCard,
  PhasesDescriptionBubbles,
  StatsCard,
} from "./";

export const MonthColumn = ({
  month,
  startingCalendarDay,
  selectedDaysState,
  setSelectedDaysState,
  modifiers,
  modifiersStyles,
  modifiersClassNames,
  phases,
  phasesAttachments,
  handlePhaseSelection,
  phasesDescriptions,
  calendarEvents,
  athleteStatsState,
  isAnnualPlanner = true,
  nutritionPlans = [],
  athleteVolumesState,
}) => {
  // Getting the number of weeks we need to display in the curren month
  // Also the hidden days that belong to the last week containing the first days of the next month
  const [numberOfWeeks, hiddenDays] = getColumnMonthData(
    month,
    startingCalendarDay
  );

  return (
    <div role="month-column">
      {/* This is a monthly calendar corresponding to each month */}
      <MonthCard
        month={month}
        hiddenDays={hiddenDays}
        startingCalendarDay={startingCalendarDay}
        selectedDaysState={selectedDaysState}
        setSelectedDaysState={setSelectedDaysState}
        modifiers={modifiers}
        modifiersStyles={modifiersStyles}
        modifiersClassNames={modifiersClassNames}
      />
      {isAnnualPlanner ? (
        <React.Fragment>
          {/* This card shows the training phases corresponding to the month */}
          <PhaseCard
            numberOfWeeks={numberOfWeeks}
            month={month}
            phases={phases}
            startingCalendarDay={startingCalendarDay}
            phasesAttachments={phasesAttachments}
            handlePhaseSelection={handlePhaseSelection}
          />
          {/* Phases descriptions corresponding to each week of the month */}
          <PhasesDescriptionBubbles
            numberOfWeeks={numberOfWeeks}
            month={month}
            startingCalendarDay={startingCalendarDay}
            phasesAttachments={phasesAttachments}
            phasesDescriptions={phasesDescriptions}
          />
          {!!calendarEvents.length && (
            // If there are events we show the weekly counter until the event
            <EventCounter
              numberOfWeeks={numberOfWeeks}
              calendarEvents={calendarEvents}
              month={month}
              startingCalendarDay={startingCalendarDay}
            />
          )}
          {/* At the end we have the card with the athlete stats */}
          <StatsCard
            month={month}
            startingCalendarDay={startingCalendarDay}
            numberOfWeeks={numberOfWeeks}
            athleteStatsState={athleteStatsState}
            athleteVolumesState={athleteVolumesState}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <NutritionTargets
            month={month}
            startingCalendarDay={startingCalendarDay}
            numberOfWeeks={numberOfWeeks}
            nutritionPlans={nutritionPlans}
          />
          <NutritionTargets
            month={month}
            startingCalendarDay={startingCalendarDay}
            numberOfWeeks={numberOfWeeks}
            nutritionPlans={nutritionPlans}
            restDay={true}
          />
          <StatsCard
            month={month}
            startingCalendarDay={startingCalendarDay}
            numberOfWeeks={numberOfWeeks}
            athleteStatsState={athleteStatsState}
            isAnnualPlanner={isAnnualPlanner}
          />
        </React.Fragment>
      )}
    </div>
  );
};
